/* MTP pre-checkout selector. Pricing must be enforced by a Shopify discount app. */
(() => {
  const helpers = {
    subtotal(cart) { return cart.items.filter(item => !helpers.managed(item)).reduce((sum, item) => sum + item.original_line_price, 0); },
    tier(total, thresholds) {
      if (total < thresholds[0]) return 0;
      if (total <= thresholds[1]) return 1;
      if (total <= thresholds[2]) return 2;
      return 3;
    },
    managed(item) { return item.properties && item.properties._mtp_free_gift === 'v1'; },
    validGift(cart, id, tier) {
      const gifts = cart.items.filter(helpers.managed);
      return gifts.length === 1 && String(gifts[0].variant_id) === String(id)
        && String(gifts[0].properties._mtp_gift_tier) === String(tier)
        && gifts[0].quantity === 1 && gifts[0].final_line_price === 0;
    }
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = helpers; return; }
  const init = () => {
    const host = document.querySelector('[data-mtp-gifts]');
    if (!host || host.dataset.initialized) return;
    host.dataset.initialized = 'true';
    const config = JSON.parse(host.querySelector('[data-mtp-config]').textContent);
    if (!config.enabled || !config.ready) return;
    if (!Array.isArray(config.thresholds) || config.thresholds.length !== 3 ||
        !config.thresholds.every(Number.isFinite) || config.thresholds[0] < 0 ||
        config.thresholds[0] >= config.thresholds[1] || config.thresholds[1] >= config.thresholds[2]) return;
    const dialog = host.querySelector('dialog');
    const grid = host.querySelector('[data-mtp-grid]');
    const heading = host.querySelector('#mtp-gifts-heading');
    const defaultHeading = heading.textContent;
    const spinner = document.createElement('span'); spinner.className = 'mtp-gift-spinner';
    spinner.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 3; i++) spinner.append(document.createElement('span'));
    dialog.prepend(spinner);
    const defaultSkip = skip => skip.textContent;
    const message = host.querySelector('[data-mtp-message]');
    const status = host.querySelector('[data-mtp-status]');
    const choose = host.querySelector('[data-mtp-choose]');
    const skip = host.querySelector('[data-mtp-skip]');
    const clear = host.querySelector('[data-mtp-clear]');
    const close = host.querySelector('[data-mtp-close]');
    const defaultSkipText = defaultSkip(skip);
    const keepShopping = document.createElement('button');
    keepShopping.type = 'button'; keepShopping.className = 'btn btn--primary';
    keepShopping.textContent = 'Keep shopping'; keepShopping.hidden = true;
    choose.parentElement.prepend(keepShopping);
    const tiersLink = document.createElement('a');
    tiersLink.href = 'https://mntrapline.com/pages/free-gift-1';
    tiersLink.textContent = 'Explore free gift tiers'; tiersLink.className = 'mtp-gift-tiers-link';
    choose.parentElement.prepend(tiersLink);
    const root = window.Shopify?.routes?.root || '/';
    let busy = false, activeTier = 0, selected = null, origin = null, uncertain = false;
    const money = (value, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(value / 100);
    const api = async (path, body) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(root + path, {
          method: body === undefined ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          ...(body === undefined ? {} : { body: JSON.stringify(body) }), signal: controller.signal
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Unable to update your cart. Please try again.');
        return data;
      } finally { clearTimeout(timer); }
    };
    const lock = value => {
      busy = value;
      dialog.setAttribute('aria-busy', String(value));
      for (const button of dialog.querySelectorAll('button')) button.disabled = value;
      choose.disabled = value || !selected;
    };
    const clean = async () => {
      const cart = await api('cart.js');
      const updates = {};
      for (const item of cart.items.filter(helpers.managed)) updates[item.key] = 0;
      if (Object.keys(updates).length) await api('cart/update.js', { updates });
      uncertain = false;
      return api('cart.js');
    };
    const render = cart => {
      host.classList.remove('mtp-gifts--below-tier');
      heading.textContent = defaultHeading;
      choose.hidden = false; keepShopping.hidden = true;
      skip.textContent = defaultSkipText;
      grid.classList.remove('mtp-gift-grid--locked');
      selected = null;
      skip.hidden = false; clear.hidden = true;
      activeTier = helpers.tier(helpers.subtotal(cart), config.thresholds);
      grid.replaceChildren();
      choose.disabled = true;
      if (cart.currency !== config.currency) {
        activeTier = 0;
        message.textContent = 'Gift offers are unavailable in this currency. You can continue without a gift.';
        return;
      }
      if (!activeTier) {
        host.classList.add('mtp-gifts--below-tier');
        heading.textContent = 'You’re within range.';
        message.replaceChildren();
        const amount = document.createElement('strong'); amount.className = 'mtp-gift-remaining';
        amount.textContent = `${money(config.thresholds[0] - helpers.subtotal(cart), cart.currency)} away`;
        const encouragement = document.createElement('span'); encouragement.className = 'mtp-gift-encouragement';
        encouragement.append(document.createTextNode('Add a little more gear to your cart to '));
        const reward = document.createElement('strong'); reward.textContent = 'unlock a FREE GIFT';
        encouragement.append(reward, document.createTextNode('.'));
        message.append(amount, encouragement);
        choose.hidden = true; keepShopping.hidden = false;
        skip.textContent = 'Continue to checkout';
        grid.classList.add('mtp-gift-grid--locked');
        for (let tier = 1; tier <= 3; tier++) {
          const gift = config.gifts.find(g => g.tier === tier && g.available && g.id);
          const card = document.createElement('div'); card.className = 'mtp-gift-card mtp-gift-card--locked';
          const badge = document.createElement('small'); badge.className = 'mtp-gift-lock';
          badge.textContent = 'Locked';
          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('viewBox', '0 0 24 24'); icon.setAttribute('aria-hidden', 'true');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M7 10V7a5 5 0 0 1 10 0v3M5 10h14v11H5zM12 14v3');
          icon.append(path); badge.prepend(icon); card.append(badge);
          if (gift?.image) { const img = document.createElement('img'); img.src = gift.image; img.alt = ''; img.loading = 'lazy'; card.append(img); }
          const title = document.createElement('span'); title.textContent = gift?.title || `Tier ${tier} gift`; card.append(title);
          if (gift?.variant && gift.variant !== 'Default Title') { const variant = document.createElement('small'); variant.textContent = gift.variant; card.append(variant); }
          const spend = config.thresholds[tier - 1];
          const badgeAmount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cart.currency, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(spend / 100);
          const unlock = document.createElement('strong'); unlock.className = 'mtp-gift-unlock';
          unlock.textContent = `Tier ${tier} • ${badgeAmount}+`;
          const note = document.createElement('small'); note.textContent = 'Sample gift • One choice from your qualifying tier'; card.append(note);
          card.append(unlock);
          grid.append(card);
        }
        return;
      }
      heading.textContent = `Congrats, you’ve unlocked a Tier ${activeTier} gift!`;
      const gifts = config.gifts.filter(g => g.tier === activeTier && g.available && g.id);
      message.textContent = activeTier
        ? `Your subtotal before discounts is ${money(helpers.subtotal(cart), cart.currency)}. Choose one complimentary gift, or continue without one.`
        : `Your subtotal before discounts is ${money(helpers.subtotal(cart), cart.currency)}. Free gifts start at ${money(config.thresholds[0], cart.currency)}. You can continue without a gift.`;
      if (activeTier && !gifts.length) message.textContent += ' No gifts are currently available for this tier.';
      for (const gift of gifts) {
        const label = document.createElement('label'); label.className = 'mtp-gift-card';
        const input = document.createElement('input'); input.type = 'radio'; input.name = 'mtp-gift-choice'; input.value = gift.id;
        input.addEventListener('change', () => { selected = gift; choose.disabled = busy || uncertain; skip.hidden = true; clear.hidden = false; status.textContent = ''; });
        label.append(input);
        if (gift.image) { const img = document.createElement('img'); img.src = gift.image; img.alt = ''; img.loading = 'lazy'; label.append(img); }
        const title = document.createElement('span'); title.textContent = gift.title; label.append(title);
        const variant = document.createElement('small'); variant.textContent = gift.variant; if (gift.variant && gift.variant !== 'Default Title') label.append(variant);
        grid.append(label);
      }
    };
    const open = async trigger => {
      if (busy || dialog.open) return;
      origin = trigger; status.textContent = ''; selected = null;
      host.classList.remove('mtp-gifts--below-tier');
      heading.textContent = 'Checking your cart…';
      message.textContent = 'Getting your gift options ready.';
      grid.replaceChildren(); grid.classList.remove('mtp-gift-grid--locked');
      choose.hidden = true; skip.hidden = true; clear.hidden = true; keepShopping.hidden = true;
      host.classList.add('mtp-gifts--loading');
      heading.setAttribute('role', 'status');
      const minimumLoading = new Promise(resolve => setTimeout(resolve, 2000));
      dialog.showModal(); lock(true);
      try {
        // Save the order note before leaving the cart form.
        const form = trigger?.form;
        const note = form?.querySelector('[name="note"]');
        const updates = {};
        for (const input of document.querySelectorAll('[data-mtp-line-key]')) {
          if (input.value !== input.dataset.initialValue && input.checkValidity()) {
            updates[input.dataset.mtpLineKey] = Number(input.value);
          }
        }
        if (note || Object.keys(updates).length) await api('cart/update.js', {
          ...(note ? { note: note.value } : {}), ...(Object.keys(updates).length ? { updates } : {})
        });
        const cart = await clean();
        await minimumLoading;
        render(cart);
      } catch (error) { uncertain = true; status.textContent = 'We could not refresh your cart. Close this window and reload the cart before trying again.'; }
      finally {
        await minimumLoading;
        host.classList.remove('mtp-gifts--loading'); heading.removeAttribute('role');
        if (uncertain) { heading.textContent = 'Unable to check your cart'; message.textContent = ''; }
        lock(false);
      }
    };
    const checkout = () => { window.location.assign(root + 'checkout'); };
    const cancel = () => {
      if (busy) return;
      dialog.close();
      // Refresh cart prices and rows after removing a previous gift.
      window.location.assign(root + 'cart');
    };
    clear.addEventListener('click', () => {
      if (busy) return;
      selected = null;
      for (const input of grid.querySelectorAll('input')) input.checked = false;
      choose.disabled = true; skip.hidden = false; clear.hidden = true;
      status.textContent = '';
    });
    keepShopping.addEventListener('click', cancel);
    close.addEventListener('click', cancel);
    dialog.addEventListener('cancel', event => { event.preventDefault(); cancel(); });
    skip.addEventListener('click', async () => {
      lock(true); status.textContent = '';
      try { await clean(); checkout(); }
      catch (error) { status.textContent = 'Unable to confirm your cart. Please reload the cart before continuing.'; lock(false); }
    });
    choose.addEventListener('click', async () => {
      if (!selected || uncertain) return;
      const gift = selected;
      lock(true); status.textContent = '';
      try {
        const cart = await clean();
        if (cart.currency !== config.currency || helpers.tier(helpers.subtotal(cart), config.thresholds) !== activeTier) {
          render(cart); status.textContent = 'Your cart changed. Please choose from the updated gifts.'; lock(false); return;
        }
        uncertain = true;
        await api('cart/add.js', { items: [{ id: gift.id, quantity: 1, properties: { _mtp_free_gift: 'v1', _mtp_gift_tier: String(activeTier) } }] });
        const updated = await api('cart.js');
        if (!helpers.validGift(updated, gift.id, activeTier) || helpers.tier(helpers.subtotal(updated), config.thresholds) !== activeTier) {
          render(await clean());
          status.textContent = 'This gift could not be discounted to $0, so it was removed from your cart. You can continue without a gift.';
          lock(false); return;
        }
        uncertain = false; checkout();
      } catch (error) {
        try { render(await clean()); status.textContent = 'The gift could not be added. Please try again or continue without a gift.'; }
        catch (_) { uncertain = true; selected = null; status.textContent = 'Unable to confirm your cart. Reload the cart before continuing.'; }
        lock(false);
      }
    });
    // Capture both ordinary checkout clicks and keyboard form submissions.
    document.addEventListener('click', event => {
      const button = event.target.closest('button[name="checkout"], input[name="checkout"], a[href]');
      if (!button || host.contains(button)) return;
      if (button.tagName === 'A') {
        const url = new URL(button.href, location.href);
        if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
      }
      if (button.disabled || (button.form && !button.form.reportValidity())) return;
      event.preventDefault(); event.stopImmediatePropagation(); open(button);
    }, true);
    document.addEventListener('submit', event => {
      if (event.submitter?.name !== 'checkout') return;
      event.preventDefault(); event.stopImmediatePropagation(); open(event.submitter);
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => { /* Refresh once to avoid stale editor listeners. */ });
})();
